import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navigationItems = [
  {
    label: 'Início',
    path: '/dashboard',
    icon: 'Home',
    description: 'Dashboard principal'
  },
  {
    label: 'Novo Jogo',
    path: '/match-details',
    icon: 'Plus',
    description: 'Organizar nova partida'
  },
  {
    label: 'Quadras',
    path: '/venue-search',
    icon: 'MapPin',
    description: 'Encontrar locais'
  },
  {
    label: 'Churrascos',
    path: '/barbecue-planning',
    icon: 'Utensils',
    description: 'Planejar eventos'
  },
  {
    label: 'Perfil',
    path: '/user-profile',
    icon: 'User',
    description: 'Minha conta'
  }];


  const notifications = [
  {
    id: 1,
    type: 'match',
    title: 'Novo jogo confirmado',
    message: 'Jogo de sábado às 14h no Campo do Morumbi',
    time: '5 min atrás',
    unread: true
  },
  {
    id: 2,
    type: 'payment',
    title: 'Pagamento pendente',
    message: 'R$ 25,00 para o jogo de domingo',
    time: '1h atrás',
    unread: true
  },
  {
    id: 3,
    type: 'barbecue',
    title: 'Churrasco confirmado',
    message: 'Lista de compras atualizada para o churrasco',
    time: '2h atrás',
    unread: false
  }];


  const unreadCount = notifications?.filter((n) => n?.unread)?.length;

  const isActive = (path) => location?.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const handleNotificationClick = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'match':return 'Calendar';
      case 'payment':return 'CreditCard';
      case 'barbecue':return 'Utensils';
      default:return 'Bell';
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-card border-b border-border shadow-elevation-1">
      <div className="flex h-16 items-center px-4 lg:px-6">
        {/* Logo */}
        <div
          className="flex items-center cursor-pointer hover-scale"
          onClick={() => handleNavigation('/dashboard')}>

          <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg mr-3">
            <svg
              viewBox="0 0 24 24"
              className="w-6 h-6 text-primary-foreground"
              fill="currentColor">

              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
              <path d="M8 12l2 2 4-4" stroke="currentColor" strokeWidth="2" fill="none" />
            </svg>
          </div>
          <div className="hidden sm:block">
            <h1 className="text-xl font-heading font-bold text-foreground">MaisJogo

            </h1>
            <p className="text-xs font-caption text-muted-foreground -mt-1">
              Seu jogo, seu jeito
            </p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-1 ml-8">
          {navigationItems?.map((item) =>
          <Button
            key={item?.path}
            variant={isActive(item?.path) ? "default" : "ghost"}
            size="sm"
            onClick={() => handleNavigation(item?.path)}
            iconName={item?.icon}
            iconPosition="left"
            iconSize={16}
            className="transition-standard">

              {item?.label}
            </Button>
          )}
        </nav>

        {/* Right Section */}
        <div className="ml-auto flex items-center space-x-2">
          {/* Quick Action Button - Desktop */}
          <div className="hidden md:block">
            <Button
              variant="secondary"
              size="sm"
              onClick={() => handleNavigation('/match-details')}
              iconName="Plus"
              iconPosition="left"
              iconSize={16}
              className="transition-spring">
              Novo Jogo
            </Button>
          </div>

          {/* Notifications */}
          <div className="relative">
            <Button
              variant="ghost"
              size="icon"
              onClick={handleNotificationClick}
              className="relative transition-standard">

              <Icon name="Bell" size={20} />
              {unreadCount > 0 &&
              <span className="absolute -top-1 -right-1 bg-error text-error-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                  {unreadCount}
                </span>
              }
            </Button>

            {/* Notification Dropdown */}
            {isNotificationOpen &&
            <div className="absolute right-0 mt-2 w-80 bg-popover border border-border rounded-lg shadow-elevation-3 z-50 animate-fade-in">
                <div className="p-4 border-b border-border">
                  <h3 className="font-heading font-semibold text-popover-foreground">
                    Notificações
                  </h3>
                  {unreadCount > 0 &&
                <p className="text-sm text-muted-foreground">
                      {unreadCount} não lida{unreadCount > 1 ? 's' : ''}
                    </p>
                }
                </div>
                <div className="max-h-96 overflow-y-auto">
                  {notifications?.map((notification) =>
                <div
                  key={notification?.id}
                  className={`p-4 border-b border-border last:border-b-0 hover:bg-muted/50 cursor-pointer transition-standard ${
                  notification?.unread ? 'bg-accent/10' : ''}`
                  }>

                      <div className="flex items-start space-x-3">
                        <div className={`p-2 rounded-lg ${
                    notification?.type === 'match' ? 'bg-primary/10 text-primary' :
                    notification?.type === 'payment' ? 'bg-warning/10 text-warning' : 'bg-secondary/10 text-secondary'}`
                    }>
                          <Icon name={getNotificationIcon(notification?.type)} size={16} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-sm text-popover-foreground">
                            {notification?.title}
                          </p>
                          <p className="text-sm text-muted-foreground mt-1">
                            {notification?.message}
                          </p>
                          <p className="text-xs text-muted-foreground mt-2 font-caption">
                            {notification?.time}
                          </p>
                        </div>
                        {notification?.unread &&
                    <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                    }
                      </div>
                    </div>
                )}
                </div>
                <div className="p-4 border-t border-border">
                  <Button
                  variant="ghost"
                  size="sm"
                  fullWidth
                  className="text-primary hover:text-primary">

                    Ver todas as notificações
                  </Button>
                </div>
              </div>
            }
          </div>

          {/* User Profile */}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => handleNavigation('/user-profile')}
            className="transition-standard">

            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <Icon name="User" size={16} color="white" />
            </div>
          </Button>

          {/* Mobile Menu Toggle */}
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="transition-standard">

              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={20} />
            </Button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMobileMenuOpen &&
      <div className="lg:hidden border-t border-border bg-card animate-slide-up">
          <nav className="p-4 space-y-2">
            {navigationItems?.map((item) =>
          <Button
            key={item?.path}
            variant={isActive(item?.path) ? "default" : "ghost"}
            fullWidth
            onClick={() => handleNavigation(item?.path)}
            iconName={item?.icon}
            iconPosition="left"
            iconSize={18}
            className="justify-start transition-standard">

                <div className="flex flex-col items-start">
                  <span>{item?.label}</span>
                  <span className="text-xs text-muted-foreground font-caption">
                    {item?.description}
                  </span>
                </div>
              </Button>
          )}
            <div className="pt-2 border-t border-border mt-4">
              <Button
              variant="secondary"
              fullWidth
              onClick={() => handleNavigation('/match-details')}
              iconName="Plus"
              iconPosition="left"
              iconSize={18}
              className="justify-start transition-spring">
                Novo Jogo
              </Button>
            </div>
          </nav>
        </div>
      }
      {/* Overlay for mobile menu */}
      {isMobileMenuOpen &&
      <div
        className="fixed inset-0 bg-black/20 z-40 lg:hidden"
        onClick={() => setIsMobileMenuOpen(false)} />

      }
      {/* Overlay for notifications */}
      {isNotificationOpen &&
      <div
        className="fixed inset-0 z-40"
        onClick={() => setIsNotificationOpen(false)} />

      }
    </header>);

};

export default Header;